import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';
import { Compiler } from '@angular/core';
import { ToastrService } from 'ngx-toastr'
import { environment } from '@/environments/environment';
import * as XLSX from 'xlsx';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public isConnected: boolean = true;
  private backUrl: string | null = null;
  private logoUrlKey = 'tenant_logo';
  private baseUrlKey = 'baseUrl';
  private baseUrl: string = '';

  constructor(public toastService: ToastrService, private http: HttpClient, private router: Router, private compiler: Compiler) { }

  backPage(url: string) { this.backUrl = url; }
  get getBackUrl(): string | null { return this.backUrl; }
  clearBackUrl() { this.backUrl = null; }
  public logoutAction(msg?: string): any {
    this.compiler.clearCache();
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/auth/sign-in']);
    this.showInfo(msg || 'Logged out successfully!');
  }


  // get getUrl(): string {
  //   return localStorage.getItem(this.baseUrlKey) || this.baseUrl;
  // }

  // initializeTenant(): Promise<void> {
  //   return new Promise((resolve) => {
  //     const savedBaseUrl = localStorage.getItem(this.baseUrlKey);
  //     const savedLogoUrl = localStorage.getItem(this.logoUrlKey);
  //     if (savedBaseUrl) {
  //       this.baseUrl = savedBaseUrl;
  //       if (savedLogoUrl) { }
  //       resolve();
  //       return;
  //     }
  //     const currentDomain = window.location.hostname;
  //     debugger
  //     const domainUrl = `${environment.RedirectURL}`.endsWith('/') ? environment.RedirectURL : `${environment.RedirectURL}/`;
  //     const apiUrl = `${domainUrl}api/tenant/get-logo-backed-details?domainURL=${currentDomain}`;
  //     // const apiUrl = `https://sahil.softrise.dev/api/tenant/get-logo-backed-details?domainURL=${currentDomain}`;

  //     this.http.get(apiUrl).subscribe({
  //       next: (res: any) => {
  //         let backendDomain = `${res?.domain}/3Mj4eXMf565PoJ/api-route/`;
  //         const logoUrl = res?.tenant__company_logo;

  //         if (backendDomain) {
  //           backendDomain = backendDomain.trim();
  //           if (!backendDomain.startsWith('http://') && !backendDomain.startsWith('https://')) {
  //             backendDomain = 'https://' + backendDomain;
  //           }
  //           let finalBaseUrl = `${backendDomain}`;
  //           finalBaseUrl = finalBaseUrl.replace(/([^:]\/)\/+/g, '$1');

  //           this.baseUrl = finalBaseUrl;
  //           localStorage.setItem(this.baseUrlKey, this.baseUrl);
  //         }

  //         if (logoUrl) {
  //           localStorage.setItem(this.logoUrlKey, logoUrl);
  //         }

  //         resolve();
  //       },
  //       error: (err) => {
  //         console.error('Failed to fetch tenant info:', err);
  //         resolve();
  //       }
  //     });
  //   });
  // }

  getTenantLogo(): string {
    return localStorage.getItem(this.logoUrlKey) ?? '';
  }



  showSuccess(msg: any, title?: any) {
    this.toastService.show(msg, '', {
      toastClass: 'btn-light text-bg-success px-3 py-2 mt-2 rounded-1',
      positionClass: 'toast-top-center',
    })
  }

  showError(msg: any, title?: any) {
    this.toastService.show(msg, '', {
      toastClass: 'toast align-items-center show text-bg-danger position-fixed top-0 start-50 translate-middle-x mt-3 px-3 py-2 rounded-1',
      positionClass: 'toast-top-center',
    })
  }

  showInfo(msg: any, title?: any) {
    this.toastService.show(msg, '', {
      toastClass: 'btn-light text-bg-primary px-3 py-2 mt-2 rounded-1',
      positionClass: 'toast-top-center',
    })
  }

  showWarning(msg: any, title?: any) {
    this.toastService.show(msg, '', {
      toastClass: 'btn-light text-bg-warning px-3 py-2 mt-2 rounded-1',
      positionClass: 'toast-top-center',
    })
  }

  copyToClipboard(copyValue: string) {
    const el = document.createElement('input');
    el.value = copyValue;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.showInfo((copyValue.toString().indexOf("http") >= 0) ? "Link Copied" : "Text Copied", null);
  };

  downloadDataFileInExcel(value: any, filename?: any): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(value);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const fileName = filename ? filename + ".csv" : 'project_data.csv';
    XLSX.writeFile(wb, fileName);
  }

  get<T>(url: string, options?: {}): Observable<any> { return this.http.get<any>(environment.RedirectURL + url, options); }

  post<T>(url: string, postBody: any, options?: {}): Observable<any> {
    return this.http.post<any>(environment.RedirectURL + url, postBody, options);
  }

  put<T>(url: string, postBody: any, options?: {}): Observable<any> { this.checkInternetConnection(); return this.http.put<any>(environment.RedirectURL + url, postBody, options); }

  delete<T>(url: string, options?: {}): Observable<any> { this.checkInternetConnection(); return this.http.delete<any>(environment.RedirectURL + url, options); }

  checkInternetConnection() { if (!window.navigator.onLine) { this.showError('Internet Connection is required'); return; } }


  downloadFileByPostAPICall(url: string, formvalue?: any): Observable<ArrayBuffer> {
    const downLoadOptions: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'arraybuffer';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer'
    };
    return this.http.post(environment.RedirectURL + url, formvalue, downLoadOptions).pipe(
      map((file: ArrayBuffer) => {
        return file;
      }));
  }

  downloadFileByGetAPICall(url: string): Observable<ArrayBuffer> {
    // let headers = new HttpHeaders();
    const downLoadOptions: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'arraybuffer';
      withCredentials?: boolean;
    } = {
      responseType: 'arraybuffer'
    };
    return this.http.get(environment.RedirectURL + url, downLoadOptions).pipe(
      map((file: ArrayBuffer) => {
        return file;
      }));
  }

  uploadFileByFormData(methodType: string, urlString: string, formData: FormData, option?: any) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(methodType, environment.RedirectURL + urlString);
      request.setRequestHeader('Authorization', 'Token ' + localStorage.getItem('token'));
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          try {
            const data = JSON.parse(request.responseText);
            if (request.status >= 200 && request.status < 300) { resolve(data); } else { reject(data); }
          } catch (err) { reject('Invalid JSON response'); }
        }
      };
      request.onerror = function () { reject('Network error'); };
      request.send(formData);
    });
  }
}

@Injectable()
export class CustomInterceptor implements HttpInterceptor {
  private isHandlingAuthError = false;
  constructor(private httpService: CommonService, private router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!navigator.onLine && this.httpService.isConnected) {
      this.httpService.isConnected = false;
      this.httpService.showError('Internet connection is required');
      return throwError(() => new Error('No internet connection'));
    }
    const token = localStorage.getItem('token');
    let headers = request.headers.set('Content-Type', 'application/json');
    if (token) { headers = headers.set('Authorization', `Token ${token}`); }
    const authReq = request.clone({ headers });
    return next.handle(authReq).pipe(
      tap((event: HttpEvent<any>) => {
        if (
          event instanceof HttpResponse &&
          event.body?.status === 200 &&
          event.body?.message
        ) {
          this.httpService.showSuccess(event.body.message);
        }
      }),
      catchError((err: HttpErrorResponse) => {
        const errorMessage = this.getErrorMessage(err);
        if (err.status === 401 || err.status === 403) {
          if (!this.isHandlingAuthError) {
            this.isHandlingAuthError = true;
            this.httpService.logoutAction(errorMessage);
            setTimeout(() => { this.isHandlingAuthError = false; }, 1000);
          }
        } else {
          this.httpService.showError(errorMessage);
        }
        return throwError(() => err);
      })
    );
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    const errorData = error.error;

    if (typeof errorData === 'string') {
      return errorData;
    }

    const message = errorData?.message || errorData?.detail || errorData?.error || (Array.isArray(errorData?.errors) ? errorData.errors[0] : errorData?.errors);
    const nonFieldErrors = Array.isArray(errorData?.non_field_errors) ? errorData.non_field_errors[0] : errorData?.non_field_errors;

    const finalMessage = message || nonFieldErrors;

    switch (error.status) {
      case 400: return finalMessage || "Some details are not valid";
      case 404: return finalMessage || "No such resource found";
      case 500: return finalMessage || "Something went wrong, please try again later";
      case 401: return finalMessage || "Unauthorized access";
      case 403: return finalMessage || "Session expired, please log in again";
      default: return finalMessage || "An unknown error occurred";
    }
  }
}
